

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};




//////////////////
// WEBPACK FOOTER
// ../node_modules/qs/lib/index.js
// module id = ../node_modules/qs/lib/index.js
// module chunks = 0